import httpService from '../common/http.service'

export const toCamelCase = text => {
	if (!text) return ''
	return text
		.toLowerCase()
		.split(' ')
		.map(word => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ')
}

export const fetchPincodeDetails = async pincode => {
	try {
		const response = await httpService.get(`/auth/pincode/${pincode}`)
		const data = response.data[0]

		if (data.Status === 'Success') {
			return data.PostOffice
		}
		return []
	} catch (error) {
		console.error('Error fetching pincode details:', error)
		return []
	}
}
